// extracted by mini-css-extract-plugin
export default {"container":"GalleryGrid_container__o1tfK","note":"GalleryGrid_note__+N3cU"};